import { render } from "./batch_update_info.vue?vue&type=template&id=17f0d45a&scoped=true"
import script from "./batch_update_info.vue?vue&type=script&lang=js"
export * from "./batch_update_info.vue?vue&type=script&lang=js"

import "./batch_update_info.vue?vue&type=style&index=0&id=17f0d45a&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f0d45a"]])

export default __exports__